import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import logger from '../../../services/logger';

import { fetchLatestRoadmapFromAPI } from './roadmap-ai.thunk';
import { UserData } from './roadmap-ai.type';

type RoadmapAiState = {
  userData: UserData | null;
  loading: boolean;
  error: string | null;
};

const initialState: RoadmapAiState = {
  userData: null,
  loading: false,
  error: null,
};

const roadmapAiSlice = createSlice({
  name: 'roadmapAi',
  initialState,
  reducers: {
    clearRoadmapAi: (state) => {
      state.userData = null;
      state.error = null;
      state.loading = false;
    },
    updateUsersRoadmapAiResponses: (state, action: PayloadAction<UserData>) => {
      logger.debug('Updating user roadmap ai state.', {
        state,
        action,
      });
      state.userData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestRoadmapFromAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchLatestRoadmapFromAPI.fulfilled,
        (state, action: PayloadAction<UserData | null>) => {
          state.loading = false;

          if (action.payload) {
            state.userData = action.payload;
          }
        },
      )
      .addCase(fetchLatestRoadmapFromAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to fetch roadmap from API';
      });
  },
});

export const {
  clearRoadmapAi,
  updateUsersRoadmapAiResponses: updateUsersRoadmapAiResponsesAction,
} = roadmapAiSlice.actions;

export default roadmapAiSlice.reducer;
